export const getHeaderTitle = (pathname: string) => {
  switch (pathname) {
    case "/dashboard":
      return "Dashboard";

    case "/package":
      return "Package";
    case "/package/create":
      return "Package";
    case "/package/edit":
      return "Package";
    case "/package/show":
      return "Package";

    case "/category":
      return "Category";
    case "/category/create":
      return "Category";
    case "/category/edit":
      return "Category";
    case "/category/show":
      return "Category";

    case "/subcategory":
      return "Subcategory";
    case "/subcategory/create":
      return "Subcategory";
    case "/subcategory/edit":
      return "Subcategory";
    case "/subcategory/show":
      return "Subcategory";

    case "/policy":
      return "Policy";
    case "/policy/create":
      return "Policy";
    case "/policy/edit":
      return "Policy";
    case "/policy/show":
      return "Policy";

    case "/legislation-link":
      return "Legislation Link";
    case "/legislation-link/create":
      return "Legislation Link";
    case "/legislation-link/edit":
      return "Legislation Link";
    case "/legislation-link/show":
      return "Legislation Link";

    case "/user":
      return "User";
    case "/user/create":
      return "User";
    case "/user/edit":
      return "User";
    case "/user/show":
      return "User";

    case "/tag":
      return "Tag";
    case "/tag/create":
      return "Tag";
    case "/tag/edit":
      return "Tag";
    case "/tag/show":
      return "Tag";

    case "/registration-group":
      return "Registration Group";
    case "/registration-group/create":
      return "Registration Group";
    case "/registration-group/edit":
      return "Registration Group";
    case "/registration-group/show":
      return "Registration Group";

    case "/form":
      return "Form";
    case "/form/create":
      return "Form";
    case "/form/edit":
      return "Form";
    case "/form/show":
      return "Form";

    case "/onboarding-step":
      return "Onboarding Step";
    case "/onboarding-step/create":
      return "Onboarding Step";
    case "/onboarding-step/edit":
      return "Onboarding Step";
    case "/onboarding-step/show":
      return "Onboarding Step";

    case "/tickets":
      return "Tickets";
    case "/user-onboarding-progress":
      return "User Onboarding Progress";
    case "/user-onboarding-progress/show":
      return "User Onboarding Progress";

    default:
      return "";
  }
};
